import React from "react";
import { Button, CircularProgress, Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import { RootStateOrAny, useSelector } from "react-redux";
import { LiaTagSolid } from "react-icons/lia";
import { BsFilter } from "react-icons/bs";
import { IoEyeOff } from "react-icons/io5";
import color from "../../../../constants/color";
import { AuthState } from "../../../../store/ducks/auth/types";
import { RenderByCargo } from "../../../../utils/RenderByCargo";
import * as Styles from "./styles";
import InputGrid from "../InputGrid";
import GradientButton from "../GradientButton";
import ButtonGrid from "../ButtonGrid";
import * as IconsSVG from "../../../../assets/iconsSVG";
import OutlinedButtonGrid from "../OutlinedButtonGrid";
import { ButtonTransferir } from "../ButtonTransferir";
import { ButtonCompartilhar } from "../ButtonCompartilhar";

interface HeaderTableLeadsInterface {
  searchBarValue: string;
  onChangeSearchBarValue: (event: any) => void;
  filtersCount: number;
  isShared: boolean;
  setFilterFunction: any;
  clearFilter: () => void;
  handleFilterOpen: () => void;
  handleTagsOpen: () => void;
  handleOpenCols: (event: React.MouseEvent<HTMLElement>) => void;
  handleClick2: (event: any) => void;
  handleTransfer: () => void;
  handleCompartilhar: () => void;
  handleExcel: () => void;
  isLoadingExcel: boolean;
  viewMode?: "lista" | "funil";
  onViewModeChange?: (mode: "lista" | "funil") => void;
}

export function HeaderTableLeads(props: HeaderTableLeadsInterface) {
  const { viewMode = "lista", onViewModeChange } = props;
  const {
    codigoCargo2013,
    codigoEmpresaVendas365,
    codigoRegional365,
    usuarioGerenteOnline,
  } = useSelector<RootStateOrAny, AuthState>((state) => state.user);
  const handleSearch = (key?: string) => {
    if (key === "Enter") {
      if (props.searchBarValue.length > 2) {
        props.setFilterFunction();
      }
      if (props.searchBarValue.length <= 2 && props.searchBarValue.length > 0) {
        toast.error("Informe no mínimo 3 caracteres");
      }
      if (props.searchBarValue === "") {
        props.setFilterFunction();
      }
    }
    if (!key) {
      if (props.searchBarValue.length > 2) {
        props.setFilterFunction();
      }
      if (props.searchBarValue.length <= 2 && props.searchBarValue.length > 0) {
        toast.error("Informe no mínimo 3 caracteres");
      }
      if (props.searchBarValue === "") {
        props.setFilterFunction();
      }
    }
  };

  return (
    <Styles.NavTable>
      <RenderByCargo
        cargo={codigoCargo2013}
        isSuperintendente={
          <>
            <Styles.Title>Carteira de leads</Styles.Title>
          </>
        }
        isGerenteVendas={
          <>
            <Styles.Title>Carteira de leads</Styles.Title>
          </>
        }
      />
      <RenderByCargo
        cargo={codigoCargo2013}
        isCorretor={
          <>
            <div style={{ display: "flex" }}>
              {viewMode !== "funil" && !props.isShared && (
                <Tooltip
                  followCursor
                  title="Ações em massa"
                  placement="top"
                  arrow
                >
                  <Styles.OnPress
                    onClick={(event) => props.handleClick2(event)}
                  >
                    <i
                      style={{
                        color: color.Almostblack,
                        fontSize: "1.4em",
                      }}
                      className="las la-ellipsis-v"
                    />
                  </Styles.OnPress>
                </Tooltip>
              )}
              {codigoRegional365?.toString() !== "2" &&
              codigoEmpresaVendas365?.toString() !== "1" &&
              codigoEmpresaVendas365?.toString() !== "4" ? (
                <Tooltip
                  followCursor
                  title="Exportar para Excel"
                  placement="top"
                  arrow
                >
                  <p>
                    <Styles.OnPress
                      onClick={() => {
                        props.handleExcel();
                      }}
                      style={{ marginLeft: 8 }}
                    >
                      {props?.isLoadingExcel ? (
                        <CircularProgress color="inherit" size={16} />
                      ) : (
                        <IconsSVG.ExportarExcelIcon />
                      )}
                    </Styles.OnPress>
                  </p>
                </Tooltip>
              ) : null}
              <OutlinedButtonGrid
                onClick={() => {
                  window.location.href = "/leads-compartilhados";
                }}
              />
            </div>
            {/* )} */}
          </>
        }
        isGerenteVendas={
          <>
            {viewMode !== "funil" &&
            codigoRegional365?.toString() !== "2" &&
            codigoEmpresaVendas365?.toString() !== "1" &&
            codigoEmpresaVendas365?.toString() !== "4" ? (
              <Tooltip
                followCursor
                title="Exportar para Excel"
                placement="top"
                arrow
              >
                <p>
                  <Styles.OnPress
                    onClick={() => {
                      props.handleExcel();
                    }}
                    style={{ marginRight: 8 }}
                  >
                    {props?.isLoadingExcel ? (
                      <CircularProgress color="inherit" size={16} />
                    ) : (
                      <IconsSVG.ExportarExcelIcon />
                    )}
                  </Styles.OnPress>
                </p>
              </Tooltip>
            ) : null}
          </>
        }
      />
      <Styles.Row style={{ marginLeft: "auto" }}>
        <div style={{ width: "max-content" }}>
          <InputGrid
            style={{ width: "100% !important", maxWidth: "500px" }}
            variant="outlined"
            value={props.searchBarValue}
            onChange={(event: any) => {
              props.onChangeSearchBarValue(event.target.value);
            }}
            onKeyDown={(event: any) => handleSearch(event.key)}
            handleBtnSearch={() => handleSearch()}
          />
        </div>

        <Tooltip followCursor title="Abrir Filtro" placement="top" arrow>
          <p>
            <Styles.OnPress
              onClick={() => {
                props.handleFilterOpen();
              }}
              style={{ marginLeft: 8, background: "#2D5BFF" }}
            >
              <BsFilter color="#FFFFFF" />
            </Styles.OnPress>
          </p>
        </Tooltip>

        <Tooltip followCursor title="Limpar filtro" placement="top" arrow>
          <p>
            <Styles.OnPress
              onClick={() => {
                props.clearFilter();
              }}
              style={{ marginLeft: 8 }}
            >
              <IconsSVG.ClearFilterGrid />
              {props.filtersCount > 0 && (
                <Styles.FiltersCount>{props.filtersCount}</Styles.FiltersCount>
              )}
            </Styles.OnPress>
          </p>
        </Tooltip>

        {/* <ButtonGrid onClick={() => props.handleFilterOpen()} /> */}
        {viewMode !== "funil" && (
          <Button
            style={{
              background: "#FFFFFF",
              color: "#2D5BFF",
              marginLeft: 8,
              height: 36,
              borderRadius: 4,
              border: "1px solid #2D5BFF",
              boxShadow: "none",
              textTransform: "none",
            }}
            sx={{ paddingLeft: 2.5, paddingRight: 2.5 }}
            variant="contained"
            startIcon={<IoEyeOff color="#2D5BFF" />}
            onClick={(event) => props.handleOpenCols(event)}
          >
            Colunas
          </Button>
        )}

        {onViewModeChange && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginLeft: 8,
              border: "1px solid #2D5BFF",
              borderRadius: 4,
              overflow: "hidden",
              height: 36,
            }}
          >
            <button
              type="button"
              onClick={() => onViewModeChange("lista")}
              style={{
                height: "100%",
                padding: "0 14px",
                border: "none",
                borderRight: "1px solid #2D5BFF",
                cursor: "pointer",
                fontFamily: "Inter",
                fontSize: 14,
                fontWeight: viewMode === "lista" ? 600 : 400,
                background: viewMode === "lista" ? "#2D5BFF" : "#FFFFFF",
                color: viewMode === "lista" ? "#FFFFFF" : "#2D5BFF",
                transition: "background 0.15s",
              }}
            >
              Lista
            </button>
            <button
              type="button"
              onClick={() => onViewModeChange("funil")}
              style={{
                height: "100%",
                padding: "0 14px",
                border: "none",
                cursor: "pointer",
                fontFamily: "Inter",
                fontSize: 14,
                fontWeight: viewMode === "funil" ? 600 : 400,
                background: viewMode === "funil" ? "#2D5BFF" : "#FFFFFF",
                color: viewMode === "funil" ? "#FFFFFF" : "#2D5BFF",
                transition: "background 0.15s",
              }}
            >
              Funil
            </button>
          </div>
        )}
        <RenderByCargo
          cargo={codigoCargo2013}
          isCorretor={
            <>
              <Button
                style={{
                  background: "#2D5BFF",
                  color: "#FFFFFF",
                  marginLeft: 8,
                  height: 36,
                  borderRadius: 4,
                  boxShadow: "none",
                  textTransform: "none",
                }}
                sx={{ paddingLeft: 2.5, paddingRight: 2.5 }}
                variant="contained"
                startIcon={<LiaTagSolid color="#FFFFFF" />}
                onClick={() => props.handleTagsOpen()}
              >
                Etiquetas
              </Button>
            </>
          }
        />

        {viewMode !== "funil" && (
          <RenderByCargo
            cargo={codigoCargo2013}
            isSuperintendente={
              <>
                <ButtonTransferir
                  disabled={usuarioGerenteOnline}
                  onClick={() => props.handleTransfer()}
                />
                <ButtonCompartilhar
                  disabled={usuarioGerenteOnline}
                  onClick={() => props.handleCompartilhar()}
                />
              </>
            }
            isGerenteVendas={
              <>
                <ButtonTransferir
                  disabled={usuarioGerenteOnline}
                  onClick={() => props.handleTransfer()}
                />
                <ButtonCompartilhar
                  disabled={usuarioGerenteOnline}
                  onClick={() => props.handleCompartilhar()}
                />
              </>
            }
          />
        )}

        <RenderByCargo
          cargo={codigoCargo2013}
          isCorretor={
            <>
              <GradientButton href="/leads-novo" />
            </>
          }
          isGerenteVendas={
            <>
              <GradientButton href="/leads-novo" />
            </>
          }
        />
      </Styles.Row>
    </Styles.NavTable>
  );
}
